// Video Call Service
import { apiService } from '../../../shared/services/api';
import {
  VideoCallSession,
  CallPermission,
  CallLog,
  InitiateCallRequest,
  AnswerCallRequest,
  EndCallRequest,
} from '../types';

export const videoCallService = {
  // Get all video call sessions
  getSessions: async (): Promise<VideoCallSession[]> => {
    return await apiService.get<VideoCallSession[]>('/video-calls/sessions/');
  },

  // Get call history
  getCallHistory: async (params?: {
    robot_id?: string;
    museum_code?: string;
    status?: string;
  }): Promise<VideoCallSession[]> => {
    const queryParams = new URLSearchParams();
    if (params?.robot_id) queryParams.append('robot_id', params.robot_id);
    if (params?.museum_code) queryParams.append('museum_code', params.museum_code);
    if (params?.status) queryParams.append('status', params.status);

    const url = queryParams.toString()
      ? `/video-calls/sessions/call_history/?${queryParams.toString()}`
      : '/video-calls/sessions/call_history/';

    return await apiService.get<VideoCallSession[]>(url);
  },

  // Initiate a video call
  initiateCall: async (data: InitiateCallRequest): Promise<VideoCallSession> => {
    return await apiService.post<VideoCallSession>('/video-calls/sessions/initiate/', data);
  },

  // Answer a video call
  answerCall: async (data: AnswerCallRequest): Promise<VideoCallSession> => {
    return await apiService.post<VideoCallSession>('/video-calls/sessions/answer/', data);
  },

  // End a video call
  endCall: async (data: EndCallRequest): Promise<VideoCallSession> => {
    return await apiService.post<VideoCallSession>('/video-calls/sessions/end_call/', data);
  },

  // Get call permissions
  getPermissions: async (): Promise<CallPermission[]> => {
    return await apiService.get<CallPermission[]>('/video-calls/permissions/');
  },

  // Get call logs
  getCallLogs: async (): Promise<CallLog[]> => {
    return await apiService.get<CallLog[]>('/video-calls/logs/');
  },

  // Get specific call session
  getCallSession: async (id: number): Promise<VideoCallSession> => {
    return await apiService.get<VideoCallSession>(`/video-calls/sessions/${id}/`);
  },
};
